import { mapActions, mapGetters, mapState } from 'vuex';
import { APP_MOBILE_ORDERBOOK_DISPLAY, APP_PRICE_DISPLAY, UX_CATEGORY } from '@/store/modules/app';
import { UX_OPTIONS_WITHOUT_MOBILE_ORDERBOOK_SETTING } from '@/components/account/settings/settings';
import loaderMixin from '@/mixins/loader';

export default {
  mixins: [loaderMixin],
  model: {
    prop: 'value',
    event: 'input',
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    'small-modal': () => import('@/components/generics/modal/small/small.vue'),
  },
  computed: {
    ...mapGetters('app', ['isLayoutMobile']),
    ...mapState('app', ['settingShowOdds', 'settingOrderbookCollapsed', 'settingColorPalette', 'settingMobileLayout']),
    settingsModalOptions() {
      return UX_OPTIONS_WITHOUT_MOBILE_ORDERBOOK_SETTING.filter(setting => (
        this.isLayoutMobile || setting.key !== UX_CATEGORY.UXSettingMobileContractLayout
      ));
    },
  },
  methods: {
    ...mapActions('app', ['setSettingShowOdds', 'setSettingOrderbookCollapsed', 'setSettingColorPalette', 'setSettingMobileLayout']),
    close() {
      this.$emit('input', false);
    },
    isOptionDisabled(option) {
      return !!option.disabled;
    },
    onSettingOptionClick(category, option) {
      if (this.isOptionDisabled(option) || this.isSelected(category, option.key)) {
        return;
      }
      this.setSettingValue(category, option.key);
    },
    setSettingValue(category, key) {
      if (category === UX_CATEGORY.UXSettingPriceDisplay) {
        this.loaderAdd(document.body);
        this.setSettingShowOdds(key === APP_PRICE_DISPLAY.ODDS)
          .then(() => this.loaderRemove(document.body))
          .catch(() => this.loaderRemove(document.body));
      } else if (category === UX_CATEGORY.UXSettingIsOBCollapsedOnOS) {
        this.loaderAdd(document.body);
        this.setSettingOrderbookCollapsed(key === APP_MOBILE_ORDERBOOK_DISPLAY.COLLAPSED)
          .then(() => this.loaderRemove(document.body))
          .catch(() => this.loaderRemove(document.body));
      } else if (category === UX_CATEGORY.UXSettingBuyColorScheme) {
        this.loaderAdd(document.body);
        this.setSettingColorPalette(key)
          .then(() => this.loaderRemove(document.body))
          .catch(() => this.loaderRemove(document.body));
      } else if (category === UX_CATEGORY.UXSettingMobileContractLayout) {
        this.loaderAdd(document.body);
        this.setSettingMobileLayout(key)
          .then(() => this.loaderRemove(document.body))
          .catch(() => this.loaderRemove(document.body));
      }
    },
    isSelected(category, key) {
      switch (category) {
        case UX_CATEGORY.UXSettingPriceDisplay:
          return this.settingShowOdds === (key === APP_PRICE_DISPLAY.ODDS);
        case UX_CATEGORY.UXSettingIsOBCollapsedOnOS:
          return this.settingOrderbookCollapsed === (key === APP_MOBILE_ORDERBOOK_DISPLAY.COLLAPSED);
        case UX_CATEGORY.UXSettingBuyColorScheme:
          return this.settingColorPalette === key;
        case UX_CATEGORY.UXSettingMobileContractLayout:
          return this.settingMobileLayout === key;
        default:
          return false;
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/market/market-settings-modal/market-settings-modal.js